var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('case-form',{attrs:{"isBoxed":false,"schema":_vm.schemaUnderwriter}}),_c('case-form',{attrs:{"isBoxed":false,"schema":[
			{
				label: 'Country of risk domicile',
				component: 'select',
				bindTo: 'case.facts.countryOfRiskDomicile',
				props: {
					options: this.countries
				}
			}
		]}}),_c('div',{staticClass:"xs-12 fs4 fw7 mb1 mt6"},[_vm._v("Producer")]),_c('berkley-commission'),_c('div',{staticClass:"xs-12 fs4 fw7 mb2 mt6"},[_vm._v("Policy Owner")]),_c('case-form',{attrs:{"schema":_vm.schemaHolder}}),_c('div',{staticClass:"xs-12 fs4 fw7 mb2 mt6"},[_vm._v("Insured")]),_c('case-form',{attrs:{"schema":_vm.schemaInsured}}),_c('products-liability-turnovers'),_c('offer-form',{staticClass:"mt6",attrs:{"schema":_vm.schemaOffer,"isBoxed":false}}),_c('case-form',{staticClass:"mt6",attrs:{"schema":_vm.schemaSubjectivity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }